import { isArray } from 'lodash';

function transformDefaultResCfg(response) {
  var _a;
  if (response.success) {
    return {
      success: response.success,
      data: isArray((_a = response === null || response === void 0 ? void 0 : response.model) === null || _a === void 0 ? void 0 : _a.result) ? response.model.result : []
    };
  }
  return {
    success: false,
    data: []
  };
}

export { transformDefaultResCfg as default };
